import { ModalController } from '@ionic/angular';
import { Component } from '@angular/core';

@Component({
    templateUrl: './cooler-welcome.page.html',
    styleUrls: ['./cooler-welcome.page.scss'],
})
export class CoolerWelcomePage {

    constructor(
        private modalCtrl: ModalController,
    ) { }


    public async onContinue() {
        await this.modalCtrl.dismiss(1);
    }

    public async onDismiss() {
        await this.modalCtrl.dismiss(2);
    }
}
